module.exports = __webpack_public_path__ + "js/0.951fee7b.worker.js"